import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireSquadPlayer} from '@tisa-group/models';

@Injectable()
export class SquadPlayerService implements CrudService<UmpireSquadPlayer> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireSquadPlayer[]>> {
    return this.http
      .get(`/squad_players`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquadPlayer>> {
    return this.http
      .get(`/squad_players/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireSquadPlayer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquadPlayer>> {
    return this.http
      .post<JsonApiResponse<UmpireSquadPlayer>>(
        '/squad_players',
        serialize({stuff: body, includeNames: ['player', 'squad']}),
        {params: objectToHttpParams(params)},
      )
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireSquadPlayer>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquadPlayer>> {
    return this.http
      .patch<JsonApiResponse<UmpireSquadPlayer>>(
        `/squad_players/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/squad_players/${id}`);
  }
}
